"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.supportsV0V1Multilocation = exports.XCM_V3_GENERAL_KEY_DATA_BYTES = void 0;
// XcmV3Junction's GeneralKey data length in bytes is 32
exports.XCM_V3_GENERAL_KEY_DATA_BYTES = 32;
const supportsV0V1Multilocation = (api) => {
    try {
        const keys = api.createType("XcmVersionedMultiLocation")
            .defKeys;
        return keys.includes("V0");
    }
    catch (e) {
        // ignore error
    }
    return false;
};
exports.supportsV0V1Multilocation = supportsV0V1Multilocation;
